export default "__VITE_ASSET__BCtex62c__"